import RecentEvaluationsController from './RecentEvaluationsController';
import './recentEvaluations.scss';
import UserService from '../../pages/user/services/userService';
import EvaluationService from '../../pages/evaluation/services/evaluationService';

const RecentEvaluations = {
    template: require('./recentEvaluationsView.html'),
    controller: RecentEvaluationsController
};

export default angular.module('app.recentevaluations', [])
  .component('recentevaluations', RecentEvaluations)
  .service('UserService', UserService)
  .service('EvaluationService', EvaluationService)
  .name;


// WEBPACK FOOTER //
// ./src/app/components/recentEvaluations/RecentEvaluationsComponent.js